import { render, staticRenderFns } from "./WidgetKeyResultNotes.vue?vue&type=template&id=a8175ebe&scoped=true&"
import script from "./WidgetKeyResultNotes.vue?vue&type=script&lang=js&"
export * from "./WidgetKeyResultNotes.vue?vue&type=script&lang=js&"
import style0 from "./WidgetKeyResultNotes.vue?vue&type=style&index=0&id=a8175ebe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8175ebe",
  null
  
)

export default component.exports